import get from 'lodash/get'
import isNil from 'lodash/isNil'

import * as Model from 'api/model'

export default function (layer) {
  if (isNil(layer)) {
    return
  }
  const titleid = get(layer, 'titleid', null)
  if (isNil(titleid)) {
    return
  }
  const layers = Model.get('config.layers', [])
  for (const key in layers) {
    let layerModel = layers[key]
    const titleidModel = get(layerModel, 'titleid', '')
    if (titleidModel === titleid) {
      layerModel = layer
    }
  }
}
